import { FormControlLabel, FormLabel, Radio, RadioGroup, TableCell, TableRow, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import InputBasic from "../../ProfilesComp/InputsBasic";

const RowADLS = ({index, fieldV, Translation, updateTableFinancial}) =>{
    const { t } = useTranslation();

    const [adlsDataRow, setAdlsDataRow] = useState({
        "DoesClientNeedAssistance": "",
        "TypeofAssistance": "",
        "SourceofAssistance": ""
    });

    const storedData = useSelector(state => state.profiles.Adl);

    useEffect(() => {
        setAdlsDataRow(() => ({
            ...storedData[fieldV]
        }));
    }, [storedData]);

    const handleChange = async(field, value) => {
        setAdlsDataRow((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };
    const handleNextStepRow = async (field, value) => {
        await handleChange(field, value);
    };

    useEffect(() => {
        updateTableFinancial({ fieldV, adlsDataRow });
    }, [adlsDataRow]);
    
    return(
        <TableRow key={index}>
            <TableCell><FormLabel component="legend">{t(Translation)}</FormLabel></TableCell>
            <TableCell>
                <RadioGroup
                        value={adlsDataRow.DoesClientNeedAssistance}
                        onChange={(e) => handleNextStepRow("DoesClientNeedAssistance", e.target.value)}
                    >
                    <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                    <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                </RadioGroup>
            </TableCell>
            <TableCell>
                <InputBasic 
                    value={adlsDataRow.TypeofAssistance || ""}  
                    onChange={(e) => handleNextStepRow("TypeofAssistance", e.target.value)}
                />
            </TableCell>
            <TableCell>
                <InputBasic 
                    value={adlsDataRow.SourceofAssistance || ""}  
                    onChange={(e) => handleNextStepRow("SourceofAssistance", e.target.value)}
                />
            </TableCell>
        </TableRow>
    )
}
export default RowADLS;